import { render, staticRenderFns } from "./WorkLocationStats.vue?vue&type=template&id=d4a21daa&"
import script from "./WorkLocationStats.vue?vue&type=script&lang=js&"
export * from "./WorkLocationStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports